import { DEFAULT_SKIN_ID, suitColor, suitGlyph, type BjPublicCard } from "@ziolo/shared";
import { SkinBackArt } from "./SkinArt.js";

export function BjCardView({
  card,
  dealDelayMs = 0,
  skinId = DEFAULT_SKIN_ID,
  animated = true,
}: {
  card: BjPublicCard;
  dealDelayMs?: number;
  skinId?: string;
  animated?: boolean;
}) {
  const style = animated ? ({ animationDelay: `${dealDelayMs}ms` } as const) : undefined;
  const skin = skinId || DEFAULT_SKIN_ID;
  const dealClass = animated ? " bj-card--deal" : "";

  if (!("suit" in card)) {
    return (
      <div
        className={`bj-card bj-card--back${dealClass}`}
        data-skin={skin}
        style={style}
        aria-label="zakryta"
      >
        <span className="bj-card__pattern">
          <SkinBackArt skinId={skin} />
        </span>
      </div>
    );
  }

  const color = suitColor(card.suit);
  const glyph = suitGlyph(card.suit);
  return (
    <div
      className={`bj-card bj-card--${color}${dealClass}`}
      data-skin={skin}
      style={style}
      aria-label={`${card.value}${glyph}`}
    >
      <span className="bj-card__corner bj-card__corner--tl">
        <span className="bj-card__rank">{card.value}</span>
        <span className="bj-card__mini">{glyph}</span>
      </span>
      <span className="bj-card__suit">{glyph}</span>
      <span className="bj-card__corner bj-card__corner--br">
        <span className="bj-card__rank">{card.value}</span>
        <span className="bj-card__mini">{glyph}</span>
      </span>
    </div>
  );
}

export function BjHandView({
  cards,
  skinId = DEFAULT_SKIN_ID,
}: {
  cards: BjPublicCard[];
  skinId?: string;
}) {
  return (
    <div className="bj-hand">
      {cards.map((card, index) => (
        <BjCardView
          key={`${index}-${"suit" in card ? card.suit + card.value : "x"}`}
          card={card}
          dealDelayMs={index * 80}
          skinId={skinId}
        />
      ))}
    </div>
  );
}
